import React from "react";
import { Microscope, Zap, CheckCircle2 } from "lucide-react";
import { technologies } from "../mock";

const iconMap = { Microscope, Zap };

export default function Technology() {
  return (
    <section id="tecnologia" className="bg-white">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-20 lg:py-28">
        <div className="grid lg:grid-cols-2 gap-14 items-center">
          <div className="reveal order-2 lg:order-1">
            <div className="relative rounded-[28px] overflow-hidden shadow-2xl shadow-blue-950/15">
              <img
                src="/assets/gallery/eyelight.webp"
                alt="Equipo Eye-Light de luz pulsada y láser"
                className="w-full h-[440px] object-cover"
              />
              <div className="absolute -bottom-px left-0 right-0 h-24 bg-gradient-to-t from-white/90 to-transparent" />
            </div>
          </div>

          <div className="order-1 lg:order-2">
            <span className="reveal block text-xs font-semibold tracking-[0.2em] uppercase text-[#1d6fc0]">
              Tecnología de última generación
            </span>
            <h2 className="reveal font-display font-extrabold text-3xl lg:text-[2.4rem] leading-tight mt-4 text-[#0b2545]">
              Equipamiento avanzado al servicio de tu visión
            </h2>
            <p className="reveal text-slate-500 mt-4 leading-relaxed">
              Contamos con tecnología de precisión para diagnosticar y tratar en la raíz
              de cada patología, ofreciendo resultados naturales y duraderos.
            </p>

            <div className="mt-8 space-y-4">
              {technologies.map((t, i) => {
                const Icon = iconMap[t.icon] || Microscope;
                return (
                  <div
                    key={t.name}
                    className="reveal card-hover rounded-2xl border border-slate-200 p-6 bg-gradient-to-b from-white to-slate-50/60"
                    style={{ transitionDelay: `${i * 80}ms` }}
                  >
                    <div className="flex items-start gap-4">
                      <div className="w-12 h-12 shrink-0 rounded-xl bg-[#0b2545] grid place-items-center text-blue-200">
                        <Icon size={22} />
                      </div>
                      <div>
                        <h3 className="font-display font-bold text-lg text-[#0b2545]">
                          {t.name}
                        </h3>
                        <div className="text-sm font-medium text-[#1d6fc0]">{t.subtitle}</div>
                        <p className="text-sm text-slate-500 mt-2 leading-relaxed">{t.desc}</p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>

            <div className="reveal flex items-center gap-2 mt-6 text-sm text-slate-600">
              <CheckCircle2 size={18} className="text-[#1d6fc0]" />
              Terapia antienvejecimiento y rejuvenecimiento periocular y facial
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
